import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';

import logo from "../Files/IBG Logo without background.svg";
import logoWhite from "../Files/IBG-Alha Technology Logo white.svg";
import logoSingleWhite from "../Files/IBG Logo single  white.svg";
import logo2 from "../Files/IBG Logo.svg";
import { Divider, Drawer, Fab, Icon } from '@mui/material';
import { AltRoute, Call, CallEnd, ChatRounded, ChatSharp, DarkMode, Light, LightMode, MarginTwoTone, Search } from '@mui/icons-material';
import { light } from '@mui/material/styles/createPalette';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Langue from './Langue';
import Mode from './Mode';
import MenuMobile from './MenuMobile';
import GetCookie from '../Services/GetCookie';
import Data from "../Data/.json"
import Footer from './Footer';
import SearchPage from './SearchPage';
import iaLogo from "../Files/ia.png";

const settings = ['Profile', 'Account', 'Dashboard', 'Logout'];

const drawerWidth = 240;

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [mode, setMode] = React.useState(localStorage.getItem('mode'))
  const navigate = useNavigate()
  const { t, i18n } = useTranslation();
  const pages = [t("accueil") + '|/', t("apropos") + '|/about', t("services") + '|/#services', t("produit") + "|/#products ", t("contactM") + "|/contact", t("carriere") + "|/career", t("articles") + "|/articles"];


  const cookieMode = GetCookie(Data.mode);

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseNavMenu = (link: string) => {
    navigate(link)
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  function handleMode() {
    setMode(mode == 'light' ? "dardk" : "light")

    localStorage.setItem("mode", mode == 'light' ? "dark" : "light")
  }

  const handleClick = (event: React.MouseEvent<HTMLDivElement>, link: string) => {
    navigate(link)
    const anchor =
      (
        (event.target as HTMLDivElement).ownerDocument || document
      ).querySelector(link.includes("#") ? ("#" + link.split("#")[1]) : "#back-to-top-anchor");

    if (anchor) {
      anchor.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    }
  };

  React.useEffect(() => {
    const currentPath = window.location.pathname + window.location.hash;
    if (currentPath.includes("#")) {
      const anchor = document.querySelector(currentPath.split("#")[1] ? ("#" + currentPath.split("#")[1]) : "#back-to-top-anchor");
      if (anchor) {
        anchor.scrollIntoView({
          block: 'start',
          behavior: 'smooth',
        });
      }
    }
  }, []);


  return (
    <AppBar position="fixed" variant='outlined' style={{ marginTop: "30px", height: "80px", background: cookieMode == 'dark' ? "#000135" : cookieMode == 'light' ? 'white' : "white" }}>
      <Container style={{ marginTop: "10px" }} maxWidth="lg" >
        <Toolbar disableGutters>
          <Box width={120} sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} className='anim-img'>
            <Link to={"/"}> <img draggable={false} src={cookieMode == "dark" ? logoWhite : logo} width={150} alt="" /></Link>
          </Box>

          <Box marginLeft={"5%"} sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} >
            {pages.map((page) => (
              <Button
                size='small'
                style={{ color: cookieMode == "dark" ? "white" : cookieMode == "light" ? "#293038" : "#293038" }}
                className='btn'
                key={page.split('|')[0]}
                onClick={(e: any) => { handleClick(e, page.split('|')[1]) }} //handleCloseNavMenu(page.split('|')[1]) }
                sx={{ my: 2, color: 'white', display: 'block' }}
              >
                {page.split('|')[0]}
              </Button>
            ))}
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton size='small'
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon color='primary' />
            </IconButton>
          </Box>
          <Box gap={1} sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }}>
            <Box style={{ marginTop: "15px" }} width={120} className='anim-img'>
              <Link to={"/"}> <img draggable={false} src={cookieMode == "dark" ? logoSingleWhite : logo2} width={40} alt="" /></Link>
            </Box>
            <Box sx={{ flexGrow: 0 }} className='action' >
              <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                <SearchPage />
                <Mode />
                <IconButton size='small' style={{ color: "rgba(255, 255, 255, .9)" }}><Langue /></IconButton>
              </Box>
            </Box>
          </Box>
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >

          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

          </Box>

          <Box sx={{ flexGrow: 0 }} className='action' >
            <Box marginTop={"-10px"} sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>

              <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                <SearchPage />
              </Box>

              <Mode />
              <IconButton size='small' style={{ color: "rgba(255, 255, 255, .9)" }}><Langue /></IconButton>
              <Fab size='small' style={{ backgroundColor: "white", boxShadow: "none" }}>
                <Tooltip title={"FOCUS IA CHAT"}><IconButton onClick={(e : any)=>{handleClick(e, "/focusia/chat")}} style={{ color: "#164F7D" }}> <img src={iaLogo} alt="" width={30} /> </IconButton></Tooltip>
              </Fab>
            </Box>


            <nav >
              <Drawer

                variant="temporary"
                open={Boolean(anchorElNav)}
                onClose={() => { setAnchorElNav(null) }}
                ModalProps={{
                  keepMounted: true, // Better open performance on mobile.
                }}
                sx={{
                  display: { xs: 'block', sm: 'none' },
                  '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
              >
                <Box height={"100%"} style={{ backgroundColor: (cookieMode == "dark") ? "#000135" : (cookieMode == "light") ? "white" : "inherit", color: (cookieMode == "dark") ? "white" : (cookieMode == "light") ? "black" : "inherit" }}>
                  <center>
                    <Box width={120} className='anim-img'>
                      <Link to={"/"}> <img draggable={false} width={"100%"} src={cookieMode == "dark" ? logoWhite : logo} alt="" /></Link>
                    </Box>
                  </center>
                  <hr />
                  <Divider />
                  {pages.map((page) => (
                    <MenuItem key={page} onClick={(e: any) => { handleClick(e, page.split('|')[1]) }}>
                      <Typography textAlign="center">{page.split('|')[0]}</Typography>
                    </MenuItem>
                  ))}
                  <Divider /><br />
                  {/* <center style={{ width: "100%", fontSize: "small" }} className='textgray'> <Footer /> </center> */}
                </Box>

              </Drawer>
            </nav>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default ResponsiveAppBar;